import type { ReactElement } from "react";
import React from "react";
import Modal from "~/components/modal.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";

type ConfirmResetProjectModalProps = {
	readonly show: boolean;
	readonly onConfirm: () => void;
	readonly onCancel: () => void;
};

export default function ConfirmResetProjectModal({
	show,
	onConfirm,
	onCancel,
}: ConfirmResetProjectModalProps): ReactElement {
	const t = useTranslator();
	return (
		<Modal show={show} title={t("WARNING!")} onClose={onCancel}>
			<Modal.Text>
				{t(
					"Are you sure you want to reset your changes? This will remove any changes you've made to your image.",
				)}
			</Modal.Text>
			<Modal.Actions
				actions={[
					{ text: t("Cancel"), onClick: onCancel, type: "ghost" },
					{ text: t("Reset"), onClick: onConfirm },
				]}
			/>
		</Modal>
	);
}
